export default __webpack_public_path__ + "static/media/codin-dark.05dc8ec3.svg";